(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 989px)').addEventListener('change', (event) => {
        this.setHeaderHeight();
        if (event.matches) this.header.classList.remove('shopify-section-header-hidden');
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const compact = window.matchMedia('(max-width: 989px)').matches;
      const cluster = this.header?.querySelector('.ri-header__sticky-cluster');
      const sticky = (compact && cluster) || this.header?.querySelector('sticky-header') || this.header?.querySelector('header') || this.header;
      const height = `${sticky.offsetHeight}px`;
      document.documentElement.style.setProperty('--header-height', height);
      if (compact && cluster) document.documentElement.style.setProperty('--ri-header-sticky-h', height);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (window.matchMedia('(max-width: 989px)').matches) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (window.matchMedia('(max-width: 989px)').matches) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  // Shopify paints a purple ring on the signed-in Shop avatar from inside its shadow root.
  // That color is not a host variable, so the open shadow gets a black ring to match the header icon.
  function riQuietAccountBrand(account) {
    const root = account && account.shadowRoot;
    if (!root) return;
    const wrap = root.querySelector('#shopify-element-wrapper');
    if (!wrap) return;
    wrap.style.setProperty('--shop-brand-color', '#000000');
    root.querySelectorAll('.account-button--shop-customer').forEach((button) => {
      button.classList.remove('animated');
      button.style.setProperty('animation', 'none', 'important');
    });
    // Shopify grows the signed-in avatar 5% under the mouse (scale: 1.05) from inside the shadow root; the header
    // icons do not move on hover (owner, 2026-10-22). Added once, as a sheet, so it outlasts the button's redraws.
    if (!root.__riNoAvatarGrow && 'adoptedStyleSheets' in root && typeof CSSStyleSheet === 'function') {
      try {
        const sheet = new CSSStyleSheet();
        sheet.replaceSync('.account-button__avatar:hover{scale:none!important;box-shadow:none!important}');
        root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
        root.__riNoAvatarGrow = true;
      } catch (e) {}
    }
    riWatchAccountSheet(account);
  }

  function riWatchAccountSheet(account) {
    const root = account && account.shadowRoot;
    const dialog = root && root.querySelector('dialog');
    if (!dialog || dialog.dataset.riSheetWatch) return;
    dialog.dataset.riSheetWatch = '1';
    const chip = account.closest('.header__icon--account, .menu-drawer__account-row');
    const sync = () => {
      if (chip) chip.classList.toggle('ri-account-open', dialog.open);
    };
    new MutationObserver(sync).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    dialog.addEventListener('close', sync);
    dialog.addEventListener('toggle', sync);
  }

  function riQuietAccountBrands() {
    document.querySelectorAll('shopify-account').forEach(riQuietAccountBrand);
  }

  if (customElements.get('shopify-account')) riQuietAccountBrands();
  else customElements.whenDefined('shopify-account').then(riQuietAccountBrands);

  // The account open event is composed but does not bubble, so listen during capture.
  // Anchor the sheet to the bottom of the Account chip. The header is taller than that chip.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      riQuietAccountBrand(event.target);

      const inDrawer = event.target.closest('header-drawer, .menu-drawer');
      const compact = window.matchMedia('(max-width: 989px)').matches;
      if (compact && inDrawer) {
        event.target.style.setProperty('--account-dialog-top', '0px');
        const details = document.getElementById('Details-menu-drawer-container');
        if (details && details.open) {
          const summary = details.querySelector('summary');
          details.classList.remove('menu-opening');
          details.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('overflow-hidden-tablet');
          const drawer = details.closest('header-drawer');
          if (drawer && drawer._riScrollLocked && window.RIScrollLock) {
            window.RIScrollLock.unlock();
            drawer._riScrollLocked = false;
          }
          if (typeof removeTrapFocus === 'function') removeTrapFocus(summary);
        }
        return;
      }

      const chip = event.target.closest('.header__icon--account') || event.target;
      const bottom = Math.max(0, Math.round(chip.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  document.querySelectorAll('.header__icon--account, .menu-drawer__account-row').forEach((chip) => {
    chip.addEventListener('click', (event) => {
      const account = chip.querySelector('shopify-account');
      const root = account && account.shadowRoot;
      if (!root) return;
      const path = event.composedPath();
      const hitControl = path.some(
        (node) =>
          node instanceof HTMLButtonElement ||
          node instanceof HTMLAnchorElement ||
          (node instanceof HTMLElement && node.getAttribute('role') === 'button')
      );
      if (hitControl) return;
      const button = root.querySelector('button, a, [role="button"]');
      if (button) button.click();
    });
  });

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
